import types from '../mutation-types';
import TicketFieldSettingsAPI from '../../api/ticketFieldSettings';

export const state = {
  records: [],
  uiFlags: { isFetching: false, isSaving: false },
};

export const getters = {
  getTicketFieldSettings: s => s.records,
  getEnabledTicketFields: s => s.records.filter(f => f.enabled).sort((a, b) => a.position - b.position),
  getTicketFieldUIFlags: s => s.uiFlags,
};

export const actions = {
  async fetchAll({ commit }) {
    commit(types.SET_TICKET_FIELD_SETTINGS, { isFetching: true });
    try {
      const { data } = await TicketFieldSettingsAPI.getAll();
      commit(types.SET_TICKET_FIELD_SETTINGS, { records: data });
    } finally {
      commit(types.SET_TICKET_FIELD_SETTINGS, { isFetching: false });
    }
  },

  async create({ commit, dispatch }, field) {
    commit(types.SET_TICKET_FIELD_SETTINGS, { isSaving: true });
    try {
      const { data } = await TicketFieldSettingsAPI.create(field);
      const { data: allFields } = await TicketFieldSettingsAPI.getAll();
      commit(types.SET_TICKET_FIELD_SETTINGS, { records: allFields });
      return data;
    } finally {
      commit(types.SET_TICKET_FIELD_SETTINGS, { isSaving: false });
    }
  },

  async update({ commit }, { id, ...field }) {
    commit(types.SET_TICKET_FIELD_SETTINGS, { isSaving: true });
    try {
      const { data } = await TicketFieldSettingsAPI.update(id, field);
      const { data: allFields } = await TicketFieldSettingsAPI.getAll();
      commit(types.SET_TICKET_FIELD_SETTINGS, { records: allFields });
      return data;
    } finally {
      commit(types.SET_TICKET_FIELD_SETTINGS, { isSaving: false });
    }
  },

  async delete({ commit }, id) {
    await TicketFieldSettingsAPI.delete(id);
    commit(types.DELETE_TICKET_FIELD_SETTING, id);
  },

  async reorder({ commit }, ids) {
    await TicketFieldSettingsAPI.reorder(ids);
    const { data } = await TicketFieldSettingsAPI.getAll();
    commit(types.SET_TICKET_FIELD_SETTINGS, { records: data });
  },
};

export const mutations = {
  [types.SET_TICKET_FIELD_SETTINGS](state, payload) {
    if ('records' in payload) state.records = payload.records;
    if ('isFetching' in payload) state.uiFlags.isFetching = payload.isFetching;
    if ('isSaving' in payload) state.uiFlags.isSaving = payload.isSaving;
  },
  [types.ADD_TICKET_FIELD_SETTING](state, field) {
    state.records = [...state.records, field];
  },
  [types.UPDATE_TICKET_FIELD_SETTING](state, field) {
    state.records = state.records.map(f => (f.id === field.id ? field : f));
  },
  [types.DELETE_TICKET_FIELD_SETTING](state, id) {
    state.records = state.records.filter(f => f.id !== id);
  },
};

export default { namespaced: true, state, getters, actions, mutations };
